var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "docsvg fullicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.8,231l80.2-80.1v46.7c0,6,4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9v-73.1c0-6-4.9-10.9-10.9-10.9h-73.1 c-6,0-10.9,4.9-10.9,10.9c0,6,4.9,10.9,10.9,10.9h46.7l-80.2,80.1c-4.3,4.3-4.3,11.2,0,15.5C284.6,235.3,291.6,235.3,295.8,231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,398.8h73.1c6,0,10.9-4.9,10.9-10.9c0-6-4.9-10.9-10.9-10.9l-46.7,0l78-77.9c4.3-4.3,4.3-11.2,0-15.5 c-2.1-2.1-4.9-3.2-7.7-3.2c-2.8,0-5.6,1.1-7.7,3.2l-78,77.9v-46.7c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9v73.1 C113.1,393.9,118,398.8,124,398.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,508.7c139.5,0,252.5-113,252.5-252.5S395,3.7,255.5,3.7S3,116.7,3,256.2S116.1,508.7,255.5,508.7z  M255.5,17.4c131.9,0,238.8,106.9,238.8,238.8S387.4,495,255.5,495S16.7,388.1,16.7,256.2S123.6,17.4,255.5,17.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M295.8,231l80.2-80.1v46.7c0,6,4.9,10.9,10.9,10.9c6,0,10.9-4.9,10.9-10.9v-73.1c0-6-4.9-10.9-10.9-10.9h-73.1 c-6,0-10.9,4.9-10.9,10.9c0,6,4.9,10.9,10.9,10.9h46.7l-80.2,80.1c-4.3,4.3-4.3,11.2,0,15.5C284.6,235.3,291.6,235.3,295.8,231z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,398.8h73.1c6,0,10.9-4.9,10.9-10.9c0-6-4.9-10.9-10.9-10.9l-46.7,0l78-77.9c4.3-4.3,4.3-11.2,0-15.5 c-2.1-2.1-4.9-3.2-7.7-3.2c-2.8,0-5.6,1.1-7.7,3.2l-78,77.9v-46.7c0-6-4.9-10.9-10.9-10.9s-10.9,4.9-10.9,10.9v73.1 C113.1,393.9,118,398.8,124,398.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.cfcab887956273854e2c5dd182dcf747.svg";
export { ForwardRef as ReactComponent };